import { useEffect } from 'react';
import useStore from '../../store';
import { validateFeatureFlag } from '../../services/featureFlagService';
import { FEATURE_FLAG } from '../../constants/general';
import { SUPPORT_ITEM_CHAT } from '../../pages/AccountSettings/components/AccountSettingsSupport';

const IGNORED_ELEMENTS = [
  'ChatCta',
  'helpMenuBtn',
  'HelpCta',
  'icon-adaClose',
  'icon-adaOpen',
  'icon-adaChat',
  'ada-chat-content',
  SUPPORT_ITEM_CHAT,
];

export const useAdaService = () => {
  const getSummaryData = useStore((state) => state.getSummaryData);
  const getPrimaryAccount = useStore((state) => state.getPrimaryAccount);
  const getPersonalAccount = useStore((state) => state.getPersonalAccount);
  const adaInstance = (<any>window).adaEmbed;

  const resetAdaChat = async () => {
    await adaInstance?.reset();
  };

  const startAdaChat = async () => {
    const { customer, business } = getSummaryData();
    const { bankInfo: { bank } } = getPrimaryAccount();

    if (!validateFeatureFlag(FEATURE_FLAG.ADA_BETA)) return;

    await resetAdaChat();

    await adaInstance.setMetaFields(
      {
        name: `${customer?.firstName} ${customer?.lastName}`.trim(),
        firstName: customer?.firstName,
        lastName: customer?.lastName,
        profile: customer?.customerProfile,
        platform: 'web',
        business_type: customer?.mainIncomeSource,
        is_llc: business?.status === 'APPROVED' && business?.type !== 'DBA',
        bank,
        role: getPersonalAccount().role || 'PRIMARY',
        language: 'en',
        mobileOverlay: true,
      },
    );
  };

  const toggleAdaChat = () => {
    adaInstance?.toggle();
  };

  const handleCloseChat = async () => {
    adaInstance?.getInfo().then((windowInfo: {
      hasActiveChatter: boolean;
      hasClosedChat: boolean;
      isChatOpen: boolean;
      isDrawerOpen: boolean;
    }) => {
      if (windowInfo.isChatOpen || windowInfo.isDrawerOpen) {
        toggleAdaChat();
      }
    });
  };

  const handleAdaLogout = async () => {
    await handleCloseChat();
    await resetAdaChat();
  };

  const handleOutsideClick = async (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (IGNORED_ELEMENTS.includes(target.id)) return;
    await handleCloseChat();
  };

  useEffect(() => {
    window.addEventListener('click', handleOutsideClick);
  }, []);

  return { toggleAdaChat, startAdaChat, handleAdaLogout };
};
